import { register } from 'register-service-worker';
import { bus, type SubscribeEventPayload } from '@/utils/event-bus';

const applicationServerPublicKey =
  'BLqqJvYc7cU6mH4GKbdCNXJ9vEgD7S22yU7pHjVte_snk5sGoX81gQ0VwwV42DD6NMBdaQdwChwBxeIHxhHj-Xs';

function urlB64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function postSubscribeObj(
  statusType: SubscribeEventPayload['status_type'],
  subscription: PushSubscription
) {
  const userAgent = navigator.userAgent.match(
    /(firefox|msie|chrome|safari|trident)/gi
  );
  let browser = '';
  if (userAgent) {
    browser = userAgent[0].toLowerCase();
  }
  bus.emit('subscribe', {
    status_type: statusType,
    subscription: subscription.toJSON(),
    browser: browser
  });
}

function subscribeUser(registration: ServiceWorkerRegistration) {
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
  registration.pushManager
    .subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    })
    .then(function(subscription) {
      postSubscribeObj('subscribe', subscription);
    })
    .catch(function(error) {
      console.error('Failed to subscribe the user: ', error);
    });
}
function unsubscribeUser(registration: ServiceWorkerRegistration) {
  registration.pushManager
    .getSubscription()
    .then(function(subscription) {
      if (subscription) {
        postSubscribeObj('unsubscribe', subscription);
        return subscription.unsubscribe();
      }
    })
    .catch(function(error) {
      console.log('Error unsubscribing', error);
    });
}

if (import.meta.env.PROD) {
  // Bridge login/logout events to the SW push-subscription lifecycle. Attach
  // bus listeners at module-load time (BEFORE `register().ready()` resolves)
  // so the cold-start case — JWT refresh fires `login` before the SW is
  // ready — isn't missed. The listeners await the registration via a Promise.
  let registrationResolve: (r: ServiceWorkerRegistration) => void;
  const registrationReady = new Promise<ServiceWorkerRegistration>(resolve => {
    registrationResolve = resolve;
  });

  bus.on('login', async () => {
    subscribeUser(await registrationReady);
  });
  bus.on('logout', async () => {
    unsubscribeUser(await registrationReady);
  });

  register(`${import.meta.env.BASE_URL}service-worker.js`, {
    ready(registration: ServiceWorkerRegistration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      );
      registrationResolve(registration);
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}
